/** @format */

import { Box, ButtonBase, Popover } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

// House info button: small white "i" on a light grey dot that darkens on hover.
function InfoDot({ label, children }) {
  const [anchor, setAnchor] = useState(null);
  return (
    <>
      <ButtonBase
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        onKeyDown={(e) => e.stopPropagation()}
        sx={{
          width: 44,
          height: 44,
          m: '-13px',
          borderRadius: '50%',
          flexShrink: 0,
          '& .dot': {
            bgcolor: 'grey.400',
            transition: 'background-color .15s',
          },
          '&:hover .dot, &.Mui-focusVisible .dot': { bgcolor: 'grey.700' },
        }}
      >
        <Box
          className="dot"
          component="span"
          sx={{
            width: 18,
            height: 18,
            borderRadius: '50%',
            color: 'common.white',
            fontSize: 12,
            fontWeight: 700,
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            lineHeight: '18px',
            textAlign: 'center',
          }}
        >
          i
        </Box>
      </ButtonBase>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={(e) => {
          e?.stopPropagation?.();
          setAnchor(null);
        }}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        slotProps={{ paper: { sx: { p: 2, maxWidth: 320, fontSize: 14 } } }}
      >
        {children}
      </Popover>
    </>
  );
}

InfoDot.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default InfoDot;
